module.exports = __webpack_public_path__ + "img/no-volume.fc0098f6.svg";